var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "_tr-modal", appear: "" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "_modal _con",
        attrs: {
          role: _vm.role || "dialog",
          "aria-modal": "true",
          "aria-labelledby": _vm.labelledby,
          "aria-describedby": _vm.describedby,
          dir: _vm.direction
        },
        on: {
          keydown: _vm.keydown,
          mousedown: _vm._mousedown,
          touchstart: _vm._touchstart
        }
      },
      [
        _vm._t("backdrop"),
        _c(
          _vm.action ? "ib-form" : "ib-form-object",
          {
            ref: "content",
            tag: "component",
            staticClass: "_mdlg",
            style: { width: _vm.width, height: _vm.height },
            on: { success: _vm._success, error: _vm._error }
          },
          [
            _vm.$slots.default
              ? _c("div", { staticClass: "_mdef" }, [_vm._t("default")], 2)
              : _vm._e(),
            _vm.$slots.buttons
              ? _c("div", { staticClass: "_mbtn" }, [_vm._t("buttons")], 2)
              : _vm._e()
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }